import BaseStore from "@/v1/utils/BaseStore";

import {
  GET_SOFTWARE_INTEGRATIONS_START,
  GET_SOFTWARE_INTEGRATIONS_SUCCESS,
  GET_SOFTWARE_JURISDICTIONS_START,
  GET_SOFTWARE_JURISDICTIONS_SUCCESS,
  UPDATE_INTEGRATIONS_ORDER_START,
  UPDATE_INTEGRATIONS_ORDER_SUCCESS,
} from "./types";

const initialState = {
  integrations: {
    loading: false,
    loadingReOrder: false,
    results: [],
  },
  jurisdictions: {
    loading: false,
    results: [],
  },
};

const store = new BaseStore("software", initialState);

const reducer = {
  [GET_SOFTWARE_INTEGRATIONS_START]: state => ({
    ...state,
    integrations: {
      ...state.integrations,
      loading: true,
    },
  }),
  [GET_SOFTWARE_INTEGRATIONS_SUCCESS]: (state, payload) => ({
    ...state,
    integrations: {
      ...state.integrations,
      ...payload.integrations,
      loading: false,
      results: payload.integrations.results.sort((a, b) => a.priority - b.priority),
    },
  }),
  [GET_SOFTWARE_JURISDICTIONS_START]: state => ({
    ...state,
    jurisdictions: {
      ...state.jurisdictions,
      loading: true,
    },
  }),
  [GET_SOFTWARE_JURISDICTIONS_SUCCESS]: (state, payload) => ({
    ...state,
    jurisdictions: {
      ...state.jurisdictions,
      results: payload.jurisdictions,
      loading: false,
    },
  }),
  [UPDATE_INTEGRATIONS_ORDER_START]: (state, payload) => ({
    ...state,
    integrations: {
      ...state.integrations,
      loadingReOrder: true,
      results: payload.results,
    },
  }),
  [UPDATE_INTEGRATIONS_ORDER_SUCCESS]: (state, payload) => ({
    ...state,
    integrations: {
      ...state.integrations,
      results: payload.integrations.results.sort((a, b) => a.priority - b.priority),
      loadingReOrder: false,
    },
  }),
};

export default store.reducer(reducer);
